import React, { FunctionComponent } from 'react';
import { EmployeeBox, IEmployeeBox } from '../employee-box/employee-box';
import {
  OurTeamPhotosLink,
  IOurTeamPhotosLinkProps
} from '../our-team-photos-link/our-team-photos-link';
import {
  IPromoSectionProps,
  PromoSection
} from '../promo-section/promo-section';
import styles from './our-team.module.scss';

export interface IOurTeamProps {
  promoSection: IPromoSectionProps;
  featuredEmployees: IEmployeeBox[];
  internalLinktoSection: string;
  ctaText: string;
  allEmployeePhotos: string[];
  ourTeamPhotosLink: IOurTeamPhotosLinkProps;
}

export const OurTeam: FunctionComponent<IOurTeamProps> = props => {
  const { promoSection, featuredEmployees, ourTeamPhotosLink } = props;
  return (
    <div className={styles.ourTeamStyle}>
      <div className={styles.promoSectionContainer}>
        <PromoSection {...promoSection} />
      </div>
      <div className={styles.personColleciton}>
        {featuredEmployees.map((employeeData, index) => (
          <div className={styles.personBox} key={index}>
            <EmployeeBox {...employeeData} />
          </div>
        ))}
        <div className={styles.phtosLinkWrapper}>
          <OurTeamPhotosLink {...ourTeamPhotosLink} />
        </div>
      </div>
    </div>
  );
};
